import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const PrivateRoute = ({ children, roles }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // Enquanto o auth está carregando
  if (isLoading) {
    return <div className="loading-screen">Verificando acesso...</div>;
  }

  // Se não estiver logado, redireciona para login
  if (!user) {
    const fullPath = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${fullPath}`} state={{ from: location }} replace />;
  }

  // Se existir roles, verifica se a role do usuário está permitida
  if (roles && !roles.map(r => r.toLowerCase()).includes((user.role || '').toLowerCase())) {
    // Redireciona para home caso não tenha permissão
    return <Navigate to="/" replace />;
  }

  // Usuário logado e com permissão
  return children;
};

export default PrivateRoute;
